import {NewTableDef} from 'app/shared/tables/table-column-def';

export interface AttributeList {
    attributeId: number;
    value: string;
}

export class CurrentAssortmentFeaturesDetailsListModel {
    productId: number;
    productName: string;
    CategoryName: string;
    categoryIdLevel1: number;
    categoryNameLevel1: string;
    categoryIdLevel2: number;
    categoryNameLevel2: string;
    categoryIdLevel3: number;
    categoryNameLevel3: string;
    attributesList: AttributeList[];

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CurrentAssortmentFeaturesDetailsList',
            columns: [
                {columnDef: 'productId'},
                {
                    field: 'productName',
                    columnDef: 'productName',
                    header: 'Nazwa',
                    width: 30,
                    sortColumnDef: 'productName',
                    isGeneralSearchColumn: true
                },
                {
                    field: 'CategoryName',
                    columnDef: 'CategoryName',
                    header: 'Kategoria',
                    sortColumnDef: 'categoryNameLevel1',
                    filterValue: 'Categories',
                    width: 20,
                    tooltipEnabled: true
                }
            ]
        };
    }
}
